import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class BusesService {

  buses: any = [];

  httpOptions = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
  };

  constructor(private http:HttpClient) { }

  getBuses(type?, subtype?){
      let config = {
        headers: new HttpHeaders({'Content-Type':'application/json'})
      };
      if(type && subtype) {
        config["params"] = {
          filter: JSON.stringify({where:{"type":type, "subtype": subtype}})
        };
      }
      return this.http.get('/vehicles', config);
  }

  createBus(data) {
      let body = JSON.stringify(data);
      return this.http.post('/vehicles/', body, this.httpOptions);
  }

  updateBus(data) {
      let body = JSON.stringify(data);
      return this.http.put('/vehicles/' + data.id, body, this.httpOptions);
  }

  deleteBus(data) {
      return this.http.delete('/vehicles/' + data.id);
  }

  getCount(){
    return 0;
  }

  getVehicleById(vehicleId): any {
    return this.http.get('/vehicles/'+vehicleId);
  }

  getVehicleByDeviceId(deviceId): any {
    console.log('deviceId::::::::',deviceId);
    let config = {
      headers: new HttpHeaders({'Content-Type':'application/json'})
    };
    if(deviceId) {
      config["params"] = {
        filter: JSON.stringify({where:{"deviceId":deviceId}})
      };
    }
    return this.http.get('/vehicles', config);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/buses/buses.service.ts